import React from 'react'
import FormImageElement from 'components/forms/image/FormImageElement'

const ImageContent = ({
  valueContent,
  onChangeContent,
}) => {
  return (
    <FormImageElement
      isHorizontal
      value={valueContent}
      onChange={onChangeContent}
    />
  )
}

ImageContent.propTypes = {}
ImageContent.defaultProps = {}

export default ImageContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/image/ImageContent.js